<template>
    <div>
        <main class="MainCon bottom0 top0"
              :class="{'bg_red':styleName === 'main','bg_use':styleName === 'main_b','bg_green':styleName === 'main_c'}">
            <div class="myimg rel">
                <div class="iconfont icon-zuojiantou color_fff freeBackBtn"
                     v-on:click="toPrev"></div>
                <div class="freeTitle">{{title}}</div>
                <template v-if="styleName === 'main_b'">
                    <img src="@/assets/images/freeBg.png">
                </template>
                <template v-else-if="styleName === 'main_c'">
                    <img src="@/assets/images/freeBg_green.png">
                </template>
                <template v-else>
                    <img src="@/assets/images/freeBg_red.png">
                </template>
            </div>

            <div class="ml7 mr7 pt10">
                <div class="myimg"><img src="@/assets/images/freeStep.png"></div>
                <p class="f14 b tc lh32 rel mt5 color_fff">礼金专享
                    <span class="titleLeftImg"><img src="@/assets/images/titleLefts.png"></span>
                    <span class="titleRightImg"><img src="@/assets/images/titleRights.png"></span>
                </p>
                <p class="f8 tc color_fff">礼金好物购 低价精选购</p>

                <div class="liGoodBox mt12" v-for="(item,index) in list" v-on:click="toDownload"
                     :key="index">
                    <ImageExt class="goodBoxImg tc" :src="item.pict_url" mode="aspectFit" />
                    <div class="goodBoxBlock ml5">
                        <div class="goodBoxTitle mt7">{{item.title}}</div>
                        <div class="flexBox mt7 mb5">
                            <div v-if="item.coupon_discount > 0">
                                <div class="voucherBlock_damai paddingLR7">{{item.coupon_discount}}元券</div>
                            </div>
                            <div v-else>
                                <div class="voucherBlock_damai paddingLR7">无券</div>
                            </div>
                            <div v-if="item.per_face > 0">
                                <div class="voucherBlocks_damai ml5 paddingLR7">{{item.per_face}}元</div>
                            </div>
                            <div v-else>
                                <div class="voucherBlocks_damai ml5 paddingLR7">无返利</div>
                            </div>
                        </div>
                        <div class="flexBox flexBetween mt5 mr5">
                            <div class="f8 lh18">
                                <span class="color_use">￥<em
                                        class="f12">{{item.zk_final_price}}</em>&nbsp;到手价</span>
                            </div>
                            <div class="freeListBtn">立即抢</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt10 mb40" v-if="recommendList.length > 0">
                <p class="f14 b tc lh32 rel mt10 color_fff">
                    精选推荐<span class="titleLeftImg">
                <img src="@/assets/images/titleLefts.png"></span>
                    <span class="titleRightImg"><img src="@/assets/images/titleRights.png"></span>
                </p>
                <p class="f8 tc color_fff">生活好物 每日上新</p>
                <div class="ml5 mr5 mt10">
                    <div class="goodInfoBoxList flexBetween">
                        <div class="indexGoodBlock mb5 flexBox-cell-48"
                             v-for="(item,index) in recommendList" :key="index">
                            <GoodsListItem :style-name="styleName" :goods-data="item" />
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <div :class="{'freeShareBtn_damai':styleName === 'main','freeShareBtn':styleName === 'main_b','freeShareBtn_92fanli':styleName === 'main_c'}"
             v-on:click='toggleShare'>
            立即送好友礼金福利&nbsp;<em class="iconfont icon-fenxiang1"></em>
        </div>
        <div class="freeShadow" v-show="shareStatus"></div>
        <div class="freeGuide myimg" v-show="shareStatus">
            <img src="@/assets/images/shareGuide.png">
        </div>
        <div class="freeGuideBtn" v-on:click='toggleShare' v-show="shareStatus">
            <img src="@/assets/images/freeKnowBtn.png">
        </div>
    </div>
</template>

<script>
    import ImageExt from '../../components/ImageExt';
    import GoodsListItem from './TopGoodsListItem';
    import {mapState} from 'vuex';

    export default {
        components: {ImageExt, GoodsListItem},
        props: {
            title: {
                type: String
            },
            styleName: {
                type: String,
                default: 'main'
            },
            list: {
                type: Array
            },
            recommendList: {
                type: Array
            }
        },
        data() {
            return {
                shareStatus: false,
            }
        },
        computed: {
            ...mapState(['app'])
        },
        methods: {
            toDownload: function () {
                this.$router.push({name: 'download'});
            },
            toPrev: function () {
                if (this.app.history.length <= 1) {
                    this.$router.push('/')
                } else {
                    this.$router.back();
                }
            },
            toggleShare: function () {
                this.shareStatus = !this.shareStatus;
            }
        }
    }
</script>

<style scoped>

</style>
